import request from '../../plugins/request'

// 新增作品
export function addAuthorWorks (data) {
  return request({
    url: '/api/AuthorWorks/AddAuthorWorks',
    method: 'post',
    data
  })
}

export function getAuthorWorksList (data) {
  return request({
    url: '/api/AuthorWorks/GetAuthorWorksList',
    method: 'post',
    data
  })
}
// 新增作品设定
export function addAuthorWorksSetting (data) {
  return request({
    url: '/api/AuthorWorksSetting/AddAuthorWorksSetting',
    method: 'post',
    data
  })
}
// 删除作品设定
export function deleteAuthorWorksSetting (data) {
  return request({
    url: '/api/AuthorWorksSetting/DeleteAuthorWorksSetting',
    method: 'post',
    data
  })
}
// 编辑作品设定
export function updateAuthorWorksSettingInfo (data) {
  return request({
    url: '/api/AuthorWorksSetting/UpdateAuthorWorksSettingInfo',
    method: 'post',
    data
  })
}
// 获取作品设定
export function getAuthorWorksSettingList (data) {
  return request({
    url: '/api/AuthorWorksSetting/GetAuthorWorksSettingList',
    method: 'post',
    data
  })
}
// 获取作品分类设定
export function getAuthorWorksSettingTypeList (data) {
  return request({
    url: '/api/WorksSettingType/GetAuthorWorksSettingTypeList',
    method: 'post',
    data
  })
}
// 新增作品分类设定
export function addAuthorWorksSettingType (data) {
  return request({
    url: '/api/WorksSettingType/AddAuthorWorksSettingType',
    method: 'post',
    data
  })
}
// 更新作品分类设定
export function updateAuthorWorksSettingType (data) {
  return request({
    url: '/api/WorksSettingType/UpdateAuthorWorksSettingType',
    method: 'post',
    data
  })
}
// 更新作品分类类型设定
export function deletAuthorWorksSettingType (data) {
  return request({
    url: '/api/WorksSettingType/DeletAuthorWorksSettingType',
    method: 'post',
    data
  })
}
// 获取作品相关字典集合
export function getAuthorWorksDictionaryList (data) {
  return request({
    url: '/api/AuthorDictionary/GetAuthorWorksDictionaryList',
    method: 'post',
    data
  })
}
// 获取作品相关字典集合2
export function getWorksDictionaryList (data) {
  return request({
    url: '/api/Dictionary/GetWorksDictionaryList',
    method: 'post',
    baseURL: `${process.env.VUE_APP_NOVEL_API}`,
    data
  })
}
// 获取所有作品类型
export function getAuthorWorksTypeUser (data) {
  return request({
    url: '/api/AuthorWorksType/GetAuthorWorksTypeUser',
    method: 'post',
    data
  })
}
// 获取所有作品类型2
export function getTypesListByParent (data) {
  return request({
    url: '/api/Types/GetTypesListByParent',
    method: 'post',
    baseURL: `${process.env.VUE_APP_NOVEL_API}`,
    data
  })
}
// 获取作品信息
export function getAuthorWorksInfo (data) {
  return request({
    url: '/api/AuthorWorks/GetAuthorWorksInfo',
    method: 'post',
    data
  })
}
// 更新作品6个章节得简述
export function updateAuthorSketchList (data) {
  return request({
    url: '/api/AuthorSketch/UpdateAuthorSketchList',
    method: 'post',
    data
  })
}
// 获取作品6个章节得简述
export function getAuthorSketchList (data) {
  return request({
    url: '/api/AuthorSketch/GetAuthorSketchList',
    method: 'post',
    data
  })
}
// 获取作品6个章节2
export function getAuthorChapterContentList (data) {
  return request({
    url: '/api/AuthorChapterContent/GetAuthorChapterContentList',
    method: 'post',
    // baseURL: `${process.env.VUE_APP_NOVEL_API}`,
    data
  })
}
// 更新作品信息
export function updateAuthorWorksInfo (data) {
  return request({
    url: '/api/AuthorWorks/UpdateAuthorWorksInfo',
    method: 'post',
    data
  })
}
// 查询作品选中的相关字典集合
export function getAuthorWorksSelectedDictionaryList (data) {
  return request({
    url: '/api/AuthorDictionary/GetAuthorWorksSelectedDictionaryList',
    method: 'post',
    data
  })
}
// 查询作品选中的相关字典集合2
// export function getWorksSelectedDictionaryList(data) {
// 	return request({
// 		url: '/api/Dictionary/GetWorksSelectedDictionaryList',
// 		method: 'post',
// 		baseURL: `${process.env.VUE_APP_NOVEL_API}`,
// 		data
// 	})
// }
// 根据作品ID 获取作品类型
export function getAuthorWorksTypeByWorkId (data) {
  return request({
    url: '/api/AuthorWorksType/GetAuthorWorksTypeByWorkId',
    method: 'post',
    data
  })
}
// 更新作品类型关系
export function updateAuthorWorksTypeShip (data) {
  return request({
    url: '/api/AuthorWorksType/UpdateAuthorWorksTypeShip',
    method: 'post',
    data
  })
}
// 更新作品的相关字典集合
export function updateAuthorWorksSelectedDictionaryList (data) {
  return request({
    url: '/api/AuthorDictionary/UpdateAuthorWorksSelectedDictionaryList',
    method: 'post',
    data
  })
}
// 更新作品的相关字典集合2
export function updateWorksSelectedDictionaryList (data) {
  return request({
    url: '/api/Dictionary/UpdateWorksSelectedDictionaryList',
    method: 'post',
    data
  })
}
// 获取作品考勤数据
export function GetAttendanceList (data) {
  return request({
    url: '/api/AuthorReport/GetAttendanceList',
    method: 'post',
    data
  })
}
// 获取作品月写作字数
export function GetAttendanceWords (data) {
  return request({
    url: '/api/AuthorReport/GetAttendanceWords',
    method: 'post',
    data
  })
}
// 获取用户总阅读数
export function GetUserReadCount (data) {
  return request({
    url: '/api/Reports/GetUserReadCount',
    method: 'post',
    data,
    baseURL: `${process.env.VUE_APP_NOVEL_API}`
  })
}
// 获取tag 列表
export function getTypesListByParents (data) {
  return request({
    url: '/api/Types/GetTypesListByParents',
    method: 'post',
    data,
    baseURL: `${process.env.VUE_APP_NOVEL_API}`
  })
}
// 根据作品ID获取作品类型
export function getAuthorWorksTypeByWorkIdnew (data) {
  return request({
    url: '/api/AuthorWorksType/GetAuthorWorksTypeByWorkIdnew',
    method: 'post',
    data
  })
}
// 根据用户ID 获取作品的收藏数 评论数啥的
export function getBooksReadDatas (data) {
  return request({
    url: '/api/Book/GetBooksReadDatas',
    method: 'post',
    data,
    baseURL: `${process.env.VUE_APP_NOVEL_API}`
  })
}

// 获取作家管理权限的人员ID
export function getEditorGroup () {
  return request({
    url: '/api/RolesGroup/GetEditorGroup',
    method: 'post',
    baseURL: `${process.env.VUE_APP_NOVEL_API}`
  })
}
